import PropTypes from 'prop-types';
import { Colors } from '@spotahome/ui-library';

const theme = {
  base: Colors.primary,
  light: 'white',
  interaction: Colors.interaction,
  interactionDark: Colors['interaction-dark']
};

const Floorplan = ({ theme: themeKey = 'base' }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="14"
      width="8.16667"
      height="4.66667"
      transform="rotate(90 14 0)"
      fill={theme[themeKey]}
    />
    <rect
      x="14"
      y="9.33333"
      width="4.66667"
      height="14"
      transform="rotate(90 14 9.33333)"
      fill={theme[themeKey]}
    />
    <rect
      x="8.16675"
      width="8.16667"
      height="8.16667"
      transform="rotate(90 8.16675 0)"
      fill={theme[themeKey]}
    />
  </svg>
);

Floorplan.propTypes = {
  theme: PropTypes.oneOf(['base', 'light', 'interaction', 'interactionDark'])
};

export default Floorplan;
